// Language dropdown
  function lang_dropdown() {
    document.getElementById("lang_dropdown").classList.toggle("show");
}

function lang_dropdown2() {
    document.getElementById("lang_dropdown2").classList.toggle("show");
}


window.onclick = function(event) {
    if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}






var theLanguage = $('html').attr('lang');
if (theLanguage == "en") {
    var v = document.getElementById("lang_dropdown_fr");
        v.style.display = "none";
} else if(theLanguage == "fr") {
    var v = document.getElementById("lang_dropdown_en");
        v.style.display = "none";
}


$('.et-home-slider').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
});


$(".mobile-bar").on("click", function(){
    $(".mobile-menu-side").addClass("active");
    $(".mobile-sidebar-overlay").addClass("active");
    $("body").css("overflow", "hidden");
  });
  $(".sidebar-close").on("click", function(){
    $(".mobile-menu-side").removeClass("active");
    $(".mobile-sidebar-overlay").removeClass("active");
    $("body").css("overflow", "scroll");
  });
  $(".mobile-sidebar-overlay").on("click", function(){
    $(".mobile-menu-side").removeClass("active");
    $(this).removeClass("active");
    $("body").css("overflow", "scroll");
  });

if ($(window).width() < 1280)
{
    $(".mobile-menu-side-ul ul li.has-menu-items > a").on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).parent().children('.sub-menu').slideToggle('slow');
        return false;
    });
}



// -------------- Add to cart --------------------\\

if($('[data-cart-view]').length > 0){
  $('[data-cart-view]').on("click", function(e) {
      e.preventDefault();
      $(".cart-drawer-wrap").addClass("active");
      $(".cart-drawer-overlay").show();
      $(".et-drawer-overlay").hide();
      $("body").addClass("body-overflow");
  });
}

$('.product-form__buttons button.product-form__submit').on("click", function(e) {
      e.preventDefault();
      $("body").addClass("body-overflow");
});


$('.et_card_action_btn, .product-form__submit').click(function(e) {
    e.preventDefault();
    $(".et-drawer-overlay").show();

    setTimeout(function() {
        $(".et-drawer-overlay").hide();
    }, 1500);

    $(".cart-drawer-wrap").addClass("active");
    $(".cart-drawer-overlay").show();
    var id = $(this).parent().parent();
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: id.serialize(),
        success: function(data) {
            get_cart_details();
        }
    });
});


function get_cart_details() {
    $.getJSON('/cart.js', function(cart) {
        var drawer_item_html = '';
        var cart_items = cart.items;
        var total_items = cart.item_count;
        product_total_price = cart.total_price;

        $('.subtotal-content h6 span').text(my_Shop_Currency + ((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $('.cart-trigger a span').text(total_items);
        $('.drawer_count').text(`( ${total_items} items )`);
        $('[data-cart-count]').text(total_items);

        if (total_items >= 1) {
            $('.cart-empty').addClass('active');
        } else {
            $('.cart-empty').removeClass('active'); 
        }

        for (var i = 0; i <= cart_items.length; i++) {
            var product_image = cart_items[i].image;
            var product_name = cart_items[i].product_title;
            var product_id = cart_items[i].id;
            var product_name_handlize = product_name.replace(/ /g, "-").toLowerCase();
            var product_variant_option_name = cart_items[i].options_with_values[0].name;
            var product_variant_option_value = cart_items[i].options_with_values[0].value;
            var product_variant = cart_items[i].variant_title;

            if (product_variant != null) {
                var product_variant_handlize = product_variant.replace(/ /g, "-").toLowerCase();
                var no_color = 'has-variant-color';
            } else {
                var product_variant_handlize = '';
                var no_color = 'has-no-color';
            }

            var product_quantity = cart_items[i].quantity;
            var product_price = cart_items[i].price;
            // var product_price_formatted = numberWithCommas(product_price);
            var product_variant_id = cart_items[i].variant_id;
            var product_url = cart_items[i].url;
            var product_key = cart_items[i].key;
            var da_product_total_price = cart_items[i].final_line_price;

            $('.' + product_id).addClass('upsell__added');

            drawer_item_html += '<div class="cart-drawer-item">';
            drawer_item_html += '<a href="' + product_image + '" class="cart-drawer-item-thumb">';
            drawer_item_html += '<img src="' + product_image + '" alt="cart-drawer-item">';
            drawer_item_html += '</a>';
            drawer_item_html += '<div class="cart-item-content">';
            drawer_item_html += '<div class="cart-item-title-and-price">';
            drawer_item_html += '<div class="cart-item-title">';
            drawer_item_html += '<h6><a href="' + product_url + '">' + product_name + '</a></h6>';
            drawer_item_html += '<div class="prod_variation ' + no_color + '">' + product_variant_option_name + ': <span class="color-dot bg-' + product_variant_handlize + '">' + product_variant_handlize + '</span></div>';


            drawer_item_html += '</div>';
            drawer_item_html += '<div class="cart-item-price">';
            drawer_item_html += '<dfn data-id="' + product_variant_id + '">' + my_Shop_Currency + (da_product_total_price * 0.01).toFixed(2) + '</dfn>';
            drawer_item_html += '</div>';
            drawer_item_html += '</div>';
            drawer_item_html += '<div class="cart-item-counter-and-btn">';
            drawer_item_html += '<div class="cart-item-counter">';
            drawer_item_html += '<span class="qty-button minus-btn" onclick="decreaseItemCount(event, this)"><i class="flo-uniE937"></i></span>';
            drawer_item_html += '<input readonly class="input-num" name="updates[' + product_variant_id + ']" type="number" data-id="' + product_variant_id + '"  id="updates_' + product_key + '" value="' + product_quantity + '">';
            drawer_item_html += '<span class="qty-button up-btn plus-btn" onclick="increaseItemCount(event, this)"><i class="flo-uniE936"></i></span>';
            drawer_item_html += '</div>';
            drawer_item_html += '<div class="cart-item-remove-btn">';
            drawer_item_html += '<span data-id="' + product_variant_id + '" onclick="removeItem(event, this)"><i class="flo-uniE92A"></i></span>';
            drawer_item_html += ' </div>';
            drawer_item_html += ' </div>';
            drawer_item_html += '</div>';
            drawer_item_html += ' </div>';

            $('.cart-drawer-item-wrap').html(drawer_item_html);
            setTimeout(function() {
                $(".et-drawer-overlay").hide();
            }, 1500);
        }
    });
}




function increaseItemCount(e, el) {
    var myElement = el;
    var $input = myElement.previousElementSibling;
    var value = parseInt($input.value);
    if (value < 100) {
        value = value + 1;
    } else {
        value = 100;
    }
    $input.value = value;
    change_qty($input);
}

function decreaseItemCount(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value);
    if (value > 1) {
        value = value - 1;
    } else {
        value = 0;
        $(el).parent().parent().parent().parent().remove();
    }
    $input.value = value;
    change_qty($input);
}

function change_qty($input) {
    var variant_id = $($input).attr("data-id");
    var quantity = $($input).val();
    var data = {
        updates: {}
    };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {
            product_total_price = res.items_subtotal_price;
            var pro_data = res.items;
            console.log(res);
            var price = res.total_price;
            price = price / 100;
            var tot_qty = res.item_count;

            if (tot_qty >= 1) {
                $('.cart-empty').addClass('active');
            } else {
                $('.cart-empty').removeClass('active'); 
            }

            $('.cart-trigger a span').text(tot_qty);
            $('.drawer_count').text(`( ${tot_qty} items )`);
            $('[data-cart-count]').text(tot_qty);

            $('.subtotal-content h6 span').text(my_Shop_Currency + ((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));


            // var shipping_required = free_shipping_goal - (product_total_price * 0.01);
            // var shipping_progress = ((product_total_price * 0.01) * 100) / free_shipping_goal;

            // $('.shipping__progress').css('width', shipping_progress + '%');
            // if(shipping_required >= 1){
            //   $('.shipping_purchase-message').html('SPEND <em class="shipping_purchase-more">'+my_Shop_Currency+shipping_required+'</em> MORE TO GET FREE SHIPPING');
            //   $('.shipping__confirmation').text('');
            // }else{
            //   $('.shipping_purchase-message').html('<em class="shipping_purchase-more"></em> '+free_shipping_message);
            //   $('.shipping__confirmation').text('INCLUDES FREE SHIPPING!');
            // }


            jQuery.each(pro_data, function(index, item) {
                var spe_price = item.final_line_price;
                spe_price = spe_price / 100;
                if (item.id == variant_id) {
                    $('.cart-item-price dfn[data-id=' + item.id + ']').html(my_Shop_Currency + spe_price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                }
            });

            // shipping_bar_message();
        }
    });
};



function removeItem(e, el) {
    var variant_id = $(el).attr('data-id');
    console.log(variant_id);
    var data = {
        updates: {}
    };
    data.updates[variant_id] = '0';
    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(res) {
            product_total_price = res.items_subtotal_price;
            var pro_data = res.items;
            var price = res.total_price;
            price = price / 100;
            var tot_qty = res.item_count;

            $('.subtotal-content h6 span').text(my_Shop_Currency + ((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            $('.drawer_count').text(`( ${tot_qty} items )`);
            $('[data-cart-count]').text(tot_qty);


            $('.cart-trigger a span').text(tot_qty);

            //var shipping_required = free_shipping_goal - (product_total_price * 0.01);
            //var shipping_progress = ((product_total_price * 0.01) * 100) / free_shipping_goal;

            //  $('.shipping__progress').css('width', shipping_progress + '%');
            //      if(shipping_required >= 1){
            //        $('.shipping_purchase-message').html('SPEND <em class="shipping_purchase-more">'+my_Shop_Currency+shipping_required+'</em> MORE TO GET FREE SHIPPING');
            //        $('.free-ship-bottom-txt').text('');
            //      }else{
            //        $('.shipping_purchase-message').html('<em class="shipping_purchase-more"></em> '+free_shipping_message);
            //        $('.free-ship-bottom-txt').text('INCLUDES FREE SHIPPING!');
            //      }

            if (tot_qty >= 1) {
                $('.cart-empty').addClass('active');
            } else {
                $('.cart-empty').removeClass('active'); 
            }

        }
    });
    $(el).parent().parent().parent().parent().remove();
}


$(".cart-drawer-close, .cart-drawer-overlay").on("click", function() {
    $(".cart-drawer-overlay").hide();
    $(".cart-drawer-wrap").removeClass("active");
    $("body").removeClass("body-overflow");
});


window.onscroll = function() {myFunction()};

var header = document.querySelector(".et-header");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed-header");
  } else {
    header.classList.remove("fixed-header");
  }
}

/*
$.getJSON("https://api.ipstack.com/check?access_key=46041e9c8e1eec832d4a8495f3f2ae81&format=1", function(data) {
    var country_code = data.country_code;
    if(country_code !== 'BD' &&  country_code !== 'IN' &&  country_code !== 'JP') {
        window.location.href = "https://schmidt-nagel.ch";
    }
});
*/


$.getJSON("https://api.ipstack.com/check?access_key=46041e9c8e1eec832d4a8495f3f2ae81&format=1", function(data) {
    var country_code = data.country_code;
    if(country_code == 'CA') {
        document.getElementById("country_selector_wrap").style.display = "none";
    }
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$(document).ready(function(){
    if(window.matchMedia("(max-width: 767px)").matches){
        $('.home-product_wrap').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1
        });
    }
});


$(".et-collection-sidebar ul li a").each(function(){
    var url = $(this).attr("href");
    var url_location =  window.location.pathname;

    console.log(url_location);

    if(url_location == url){
        $(this).parent().addClass("active");
    }
});

$(".single_drug_fact_title a").on("click", function(){
    $(this).parent().parent().parent().find(".single_drug_fact_popup").css("display", "block");
    $(".single_drug_fact_popup_overlay").toggleClass("active");
});

$(".close, .single_drug_fact_popup_overlay").on("click", function(){
    $(".single_drug_fact_popup").css("display", "none");
    $(".single_drug_fact_popup_overlay").removeClass("active");
});





function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
var cokies = $(".country-selector-wrap").data('cokie');

$('.country-selector-close').on('click', function (e) {
    e.preventDefault();
    $(".country-selector-wrap").removeClass('active');
    setCookie('country_selector_cokie', 'Yes', cokies);
});

if (getCookie('country_selector_cokie') == 'Yes') {
    $(".country-selector-wrap").removeClass("active");
} else {
    var x = $(".country-selector-wrap").data('time');
    setTimeout(function () {
        $(".country-selector-wrap").addClass("active");
    }, x);
}